import { useRouter } from 'next/router';
import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import HeroBanner from '../Common/HeroBanner';
import FeaturedSection from './Common/FeaturedSection';
import RecentArticlesSection from './Common/RecentArticlesSection';
import CaseStudySection from './Common/CaseStudySection';
import ContactSection from '../Common/ContactSection';
import { atsContactList, atsContactList2024, ehaContactList2024, eularContactList2024, ersContactList2024, ersContactList, eularContactList, ascoContactList, aacrContactList2025 } from '../Common/DataSet/ContactData';
import OurServicesSection from './Common/OurServicesSection';
import { CaseStudyList, CaseStudyListAts2024, CaseStudyListEha2024, CaseStudyListEular2024, CaseStudyListAacr2025, CaseStudyListErs2024, OurServicesList, OurServicesListEular2024, OurServicesListErs2024, OurServicesListATS2024, OurServicesListEHA2024, OurServicesListATS2022, OurServicesListERS2023, OurServicesListEular2022, OurServicesListESMO, NewsletterList, NewsletterListAts2024, NewsletterListEha2024, NewsletterListEular2024, NewsletterListErs2024, ERSReportList, ERS2024ReportList, ReportList, atsDataList2022, ehaDataList2024, eularDataList2024, atsDataList2024, NewsletterListAacr2025, aacrDataList2025, OurServicesListAACR2025 } from './DataSet/MainData';
import NewsLetterSectionEvent from './Common/NewsLetterSectionEvent';
import ReportSliderSection from './Common/ReportSliderSection';
const Breadcrumb = dynamic(() => import('../Layouts/Breadcrumb'), { ssr: false });
import Link from "next/link";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faHome } from '@fortawesome/free-solid-svg-icons';

const herobannerData = {
    "2022": {
        background: "/img/events/png/banner_1.png",
        title: "ATS 2022 Conference",
        shortDescription: "Delveinsight's Extensive Coverage of 2022"
    },
    "2024": {
        background: "/img/events/conference/ats-conference/ats-banner.png",
        title: "ATS 2024 Conference: A Comprehensive Review and Analysis",
        shortDescription: "Delveinsight's Extensive Coverage of 2024"
    }
};

export default function AllListing({ data, year, eventName, eventSlugPrefix, slugPrefix, reportUrl, shortDescription, title, mainTitle, imageSrc }) {
    const [featureData, setFeatureData] = useState([])
    const [filterData, setFilterData] = useState([])
    useEffect(() => {
        const filterData = data?.filter((data, index) => {
            return data.years[0]?.value === year
        })

        const featureData = filterData?.filter((data) => {
            return data?.is_featured === true
        }).slice(0, 4);

        setFeatureData(featureData);
        setFilterData(filterData)
    }, [data, year])

    return (
        <>
            <HeroBanner
                background={process.env.IMG_CDN + imageSrc}
                title={title}
                shortDescription={shortDescription}
            />
            <div className={`w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto border-b`}>
                <div className='grid grid-cols-12'>
                    <div className='col-span-12'>
                        <div className="py-3">
                            <ul className="flex items-center p-0">
                                <li className="flex items-center text-xs whitespace-nowrap">
                                    <Link href="/" className="text-[#1b5df3]">
                                        <FontAwesomeIcon className='pr-4' icon={faHome} size="sm" />
                                        Home <FontAwesomeIcon className='px-2 text-gray-400' size="sm" icon={faChevronRight} />
                                    </Link>
                                </li>
                                <li className="text-xs capitalize truncate whitespace-nowrap">{eventName}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <FeaturedSection
                featureData={featureData}
                customClass=""
                eventSlugPrefix={eventSlugPrefix}
                slugPrefix={slugPrefix}
            />
            <RecentArticlesSection
                filterData={filterData}
                year={year}
                eventSlugPrefix={eventSlugPrefix}
                slugPrefix={slugPrefix}
            />
            <CaseStudySection
                data={
                    slugPrefix === 'ats-2024' ? CaseStudyListAts2024 :
                    slugPrefix === 'eha-2024' ? CaseStudyListEha2024 :
                    slugPrefix === 'eular-2024' ? CaseStudyListEular2024 :
                    slugPrefix === 'ers-2024' ? CaseStudyListErs2024 :
                    slugPrefix === 'aacr-2025' ? CaseStudyListAacr2025 :
                    CaseStudyList
                }
            />
            <NewsLetterSectionEvent
                data={
                    slugPrefix === 'ats-2024' ? NewsletterListAts2024 :
                    slugPrefix === 'eha-2024' ? NewsletterListEha2024 :
                    slugPrefix === 'eular-2024' ? NewsletterListEular2024 :
                    slugPrefix === 'ers-2024' ? NewsletterListErs2024 :
                    slugPrefix === 'aacr-2025' ? NewsletterListAacr2025 :
                    NewsletterList
                }
            />
            <ReportSliderSection
                title="Latest Reports"
                data={
                    slugPrefix === 'ats-2024' ? atsDataList2024 :
                    slugPrefix === 'eha-2024' ? ehaDataList2024 :
                    slugPrefix === 'eular-2024' ? eularDataList2024 :
                    slugPrefix === 'ers-2023' ? ERSReportList :
                    slugPrefix === 'ers-2024' ? ERS2024ReportList :
                    slugPrefix === 'eular-2022' ? ReportList :
                    slugPrefix === 'aacr-2025' ? aacrDataList2025 :
                    atsDataList2022
                }
            />
            <ContactSection
                data={
                    slugPrefix === 'ats-2022' ? atsContactList :
                    slugPrefix === 'ats-2024' ? atsContactList2024 :
                    slugPrefix === 'eha-2024' ? ehaContactList2024 :
                    slugPrefix === 'eular-2024' ? eularContactList2024 :
                    slugPrefix === 'ers-2024' ? ersContactList2024 :
                    slugPrefix === 'ers-2023' ? ersContactList :
                    slugPrefix === 'eular-2022' ? eularContactList :
                    slugPrefix === 'aacr-2025' ? aacrContactList2025 :
                    slugPrefix === 'asco-conference' && eventSlugPrefix === 'asco-conference-2022' ? ascoContactList :
                    ascoContactList
                }
                page_name={`${eventSlugPrefix?.toUpperCase()} Page`}
                form_name={`${eventSlugPrefix}-page-form`}
                endpoint="/enquiry/get-expert-cis"
                customWidth={slugPrefix === 'aacr-2025' ? 'w-full' : ''}
            />
            <OurServicesSection
                data={
                    slugPrefix === 'ats-2024' ? OurServicesListATS2024 :
                    slugPrefix === 'ats-2022' ? OurServicesListATS2022 :
                    slugPrefix === 'eha-2024' ? OurServicesListEHA2024 :
                    slugPrefix === 'eular-2024' ? OurServicesListEular2024 :
                    slugPrefix === 'ers-2024' ? OurServicesListErs2024 :
                    slugPrefix === 'eular-2022' ? OurServicesListEular2022 :
                    slugPrefix === 'ers-2023' ? OurServicesListERS2023 :
                    slugPrefix === 'esmo-conference' ? OurServicesListESMO :
                    slugPrefix === 'asco-conference' && eventSlugPrefix === 'asco-conference-2022' ? OurServicesList : 
                    slugPrefix === 'aacr-2025' ? OurServicesListAACR2025 :
                    OurServicesList
                }
                reportUrl={reportUrl}
            />
        </>
    );
}
